import React, { Fragment } from 'react';
import { pinyin } from 'pinyin-pro';

type PinyinTextProps = {
  text: string;
  className?: string;
  pinyinClassName?: string;
};

const CHINESE_CHAR_REGEX = /[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff]/;
const pinyinCache = new Map<string, string>();

const isChineseCharacter = (char: string) => CHINESE_CHAR_REGEX.test(char);

const getPinyinForChar = (char: string) => {
  const cached = pinyinCache.get(char);
  if (cached) return cached;

  const value = pinyin(char, { toneType: 'symbol' }).trim();
  pinyinCache.set(char, value);
  return value;
};

const PinyinText: React.FC<PinyinTextProps> = ({ text, className = '', pinyinClassName = '' }) => {
  const lines = String(text || '').split('\n');

  return (
    <span className={className}>
      {lines.map((line, lineIndex) => (
        <Fragment key={`line-${lineIndex}`}>
          {Array.from(line).map((char, charIndex) => {
            const key = `char-${lineIndex}-${charIndex}`;

            if (!isChineseCharacter(char)) {
              return <span key={key}>{char}</span>;
            }

            return (
              <ruby key={key} className="mx-[1px] [ruby-position:over]">
                <span>{char}</span>
                <rt className={`select-none text-[0.62em] font-normal leading-none text-slate-500 ${pinyinClassName}`}>{getPinyinForChar(char)}</rt>
              </ruby>
            );
          })}
          {lineIndex < lines.length - 1 && <br />}
        </Fragment>
      ))}
    </span>
  );
};

export default PinyinText;
